import { Footer } from "../components/Footer"
import { ExpressMethods } from "../components/deposit/ExpressMethods"
export const ExpressPage = () => {
    return (
        <div className="container">
            <ExpressMethods />
            <Footer />
        </div>
        );
}